export function scrollToAnchor(
  id: EScrolls | string,
  behavior?: ScrollBehavior
): boolean {
  const element = document.getElementById(id)

  if (id === "top") {
    window.scrollTo({ top: 0, behavior: behavior ?? "smooth" })
    return true
  }

  if (element) {
    const top = element.getBoundingClientRect().y - 130 + window.scrollY
    window.scrollTo({ top, behavior: behavior ?? "smooth" })
    return true
  }

  return false
}

export enum EScrolls {
  everywhere = "everywhere",
  editor = "editor",
  faq = "faq",
  pricing = "pricing",
  blog = "blog",
  contact = "contact",
}
